var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"classic"},[_c('TrainStation',{attrs:{"sceneId":"classic","title":"Classic Train Simulation","physics":"classic","speedValue":25,"speedUnit":"m/s"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }